import { getBuyerFirstNameFromSurveyData } from '.';
import { CheckoutState } from '../../state';
import { getFirstNameToPrefill } from '../../utils/user';

export const getFirstNameToPrefillFirstAttendeeInfo = (state: CheckoutState) =>
    getBuyerFirstNameFromSurveyData(state) || getFirstNameToPrefill(state);
